import localforage from "localforage";
import type { PersistStorage } from "@reciperoll/core";

// IndexedDB-backed storage engine for redux-persist on web, via localforage.
// Implements the PersistStorage adapter that @reciperoll/core's makeStore
// expects (all methods return Promises). localforage falls back to WebSQL /
// localStorage automatically where IndexedDB is unavailable.
const db = localforage.createInstance({
  name: "reciperoll",
  storeName: "redux_persist",
  description: "RecipeRoll web persisted Redux state",
});

export const webStorage: PersistStorage = {
  getItem: (key) => db.getItem<string>(key).then((value) => value ?? null),
  setItem: (key, value) => db.setItem(key, value),
  removeItem: (key) => db.removeItem(key),
};
